import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule)
    },
    // {
    //     path: 'home',
    //     loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
    // },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
    },
    {
        path: 'signup',
        loadChildren: () => import('./signup/signup.module').then(m => m.SignupModule)
    },
    {
        path: 'addcompany',
        loadChildren: () => import('./add-company/add-company.module').then(m => m.AddCompanyModule)
    },
    {
        path: 'addtechnician',
        loadChildren: () => import('./add-technician/add-technician.module').then(m => m.AddTechnicianModule)
    },
    {
        path: 'verification/:id',
        loadChildren: () => import('./verification/verification.module').then(m => m.VerificationModule)
    },
    {
        path: 'validatelogbook/:id',
        loadChildren: () => import('./validate-log-book/validate-log-book.module').then(m => m.ValidateLogBookModule)
    },
    {
        path: 'resetpassword/:id',
        loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule)
    },
    {
        path: 'error',
        loadChildren: () => import('./server-error/server-error.module').then(m => m.ServerErrorModule)
    },
    {
        path: 'access-denied',
        loadChildren: () => import('./access-denied/access-denied.module').then(m => m.AccessDeniedModule)
    },
    {
        path: 'not-found',
        loadChildren: () => import('./not-found/not-found.module').then(m => m.NotFoundModule)
    },
    {
        path: '**',
        redirectTo: 'not-found'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
